const refreshCart = async () => {
          console.log('refreshing cart...');
          
fetch('/?section_id=main-cart')
  .then(response => response.text())
  .then(carthtml => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(carthtml, 'text/html');
    const newCartElement = parsedHtml.querySelector('.cart__page-col:first-child');

    if (newCartElement) {
      const cartSelector = window.location.pathname === '/cart' ? '.cart__page-col:first-child': '#CartDrawer #CartDrawerForm .cart__items';
      document.querySelector(cartSelector).innerHTML = newCartElement.innerHTML;
    }
    window.tlCartGoalEmbed.toggleGifts(0, false);

    // Add event listeners back to change qty buttons
    const qtyWrappers = document.querySelectorAll('.js-qty__wrapper');
    
    qtyWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('input');
      
      const handleChangeQtyButtonClick = (flag) => {
        const itemId = input.getAttribute('id').replace('cart_updates_', '');
        const currentQuantity = parseInt(input.value, 10);
        const newQuantity = flag === 'plus' ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);
        
        fetch(`/cart/change.js?t=${new Date().getTime()}`, {
          method: 'POST',
          headers: {
            'Accept': "application/json",
            'Content-Type': "application/json"
          },
          body: JSON.stringify({
            id: itemId,
            quantity: newQuantity
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart updated');
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        })
        .finally(() => {
          refreshCart();
        });
      };

      const plusButton = wrapper.querySelector('.js-qty__adjust--plus');
      const minusButton = wrapper.querySelector('.js-qty__adjust--minus');
      
      if (plusButton) {
        plusButton.addEventListener('click', () => handleChangeQtyButtonClick('plus'));
      }
      if (minusButton) {
        minusButton.addEventListener('click', () => handleChangeQtyButtonClick('minus'));
      }
    });

  })
  .catch(error => console.error('Error fetching cart drawer:', error));
}

// window.addEventListener('load', function() {
    newRender = async () => {
        const bodyElement = document.querySelector(".salepify-fg-advanced-body");
        bodyElement.innerHTML = '<div class="loader"></div>'
        let bodyHtml = "";
        const listRuleNeedToAddGift = [];
        const listRuleNeedToRemoveGift = [];

        let availableToClaim = 0;
        let needToReload = false
        let hasRuleMetCondition = false;
        for (let i = 0; i < window.tlAdvancedFreeGift.rules.length; i++) {
            const rule = window.tlAdvancedFreeGift.rules[i];
            const ruleId = rule.id;
            const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = window.tlAdvancedFreeGift.getRemain(rule);
            
            if(claimedCount < canClaimCount) {
                rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
            }else if(claimedCount > canClaimCount){
                rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                    id: ruleId,
                    removeTime: claimedCount - canClaimCount
                }): null;
            }
            
            // Store handle of parent and child product
            const uniqueProductHandle = new Set();
            
            // Store list parent id in order current product => required => rest product 
            const listChildDisplayIds = [];
            // ChildId map quantity required
            const childMapRequiredQty = {}
            rule.listChilds.map(child =>{
                listChildDisplayIds.push(child.shopify_id);
                if(!window.tlAdvancedFreeGift.shopifyIdMapData.get(child.product_id)){
                    uniqueProductHandle.add(child.handle)
                }
                if(child.quantity){
                    childMapRequiredQty[child.shopify_id] = child.quantity;
                }
            })

            // ParentId map quantity required
            const parentMapRequiredQty = {};

            const requireParents = []
            const highPriorityParents = [];
            const lowPriorityParents = [];
            const productIdKey = rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT ? "shopify_id" : "product_id";

            if(
                (rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT) ||
                (rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.VARIANT)
            ){
                rule.listParents.map(parent =>{
                    const productId = parent[productIdKey];
                    if(!window.tlAdvancedFreeGift.shopifyIdMapData.get(productId)){
                        uniqueProductHandle.add(parent.handle);
                    }

                    if(productId == window.tlAdvancedFreeGift.currentProductId){
                        parent.quantity ? requireParents.unshift(parent.shopify_id) : highPriorityParents.unshift(parent.shopify_id);
                    }else {
                        parent.quantity ? requireParents.push(parent.shopify_id) : lowPriorityParents.push(parent.shopify_id);
                    }
                    parentMapRequiredQty[parent.shopify_id] = parent.quantity;
                })
            }

            // Store list parent id in order current product => required => rest product 
            const listParentDisplayIds = [...requireParents, ...highPriorityParents, ...lowPriorityParents];
            await window.tlAdvancedFreeGift.updateProductData(Array.from(uniqueProductHandle));
            
            if(rule.show_free_gift_widget && window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)){
                if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                    hasRuleMetCondition = true;
                }
                const totalGift = rule.gift_qty * window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
                
                bodyHtml += `
                    <div id="salepify-fg-advanced-main-section-${ruleId}"  
                        class="salepify-fg-advanced-main-section block--flex 
                        ${i == 0 ? " salepify-fg-advanced-main-section--view-more" : " salepify-fg-advanced-main-section--view-less"}
                        ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET ? " salepify-fg-advanced-main-section--allow-claim" : ""}
                        ${conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ? " salepify-fg-advanced-main-section--claimed" : ""}" 
                    >
                        <div class="block--flex-inline flex--space-between">
                            <div class= "salepify-fg-advanced-main-section__offer-title text--bold">
                                ${conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET ? 
                                    window.tlAdvancedFreeGift.handleReplaceVariable(rule, window.tlAdvancedFreeGift.getOfferTitle(rule), remain, remainSpecific, totalGift) : 
                                    window.tlAdvancedFreeGift.translation.main_offer.eligible_offer_title
                                }
                            </div>
                            
                            <div 
                                class="salepify-fg-advanced-main-section__view-offer-btn btn--plain" 
                                onclick='window.tlAdvancedFreeGift.handleViewMore("${ruleId}")'
                            >
                                ${i == 0 ? window.tlAdvancedFreeGift.translation.main_offer.view_less : window.tlAdvancedFreeGift.translation.main_offer.view_more}
                            </div>
                        </div>
                        
                        <div class="salepify-fg-advanced-offer block--flex-inline">
                            ${window.tlAdvancedFreeGift.renderOffer(listParentDisplayIds)}
                        </div>

                        <div class="divider"></div>
                        
                        <div class="salepify-fg-advanced-customer-buy block--flex block--collapsible">
                            ${window.tlAdvancedFreeGift.renderCustomerBuy(listParentDisplayIds, parentMapRequiredQty)}
                        </div>

                        <div class="salepify-fg-advanced-main-section__upsell-banner">
                            ${window.tlAdvancedFreeGift.handleReplaceVariable(
                                rule, 
                                window.tlAdvancedFreeGift.renderUpsellMsg(conditionState, rule.auto_add_gift), 
                                remain, 
                                remainSpecific, 
                                totalGift
                            )}
                        </div>

                        <div class="salepify-fg-advanced-gift-list block--flex block--collapsible">
                            ${window.tlAdvancedFreeGift.renderGifts(
                                listChildDisplayIds, 
                                childMapRequiredQty, 
                                conditionState,
                                rule
                            )}

                        </div>
                      
                        <div class="salepify-fg-advanced-footer block--flex-inline flex--space-between block--collapsible"
                            style="display: ${(conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET && !rule.auto_add_gift) ? "flex" : "none"}"
                        >
                            <div class="salepify-fg-advanced-footer__remain-gift-title">
                                ${window.tlAdvancedFreeGift.translation.manual_choose_gift.selected_text} 
                                ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                    window.tlAdvancedFreeGift.getTotalSelectedGift(ruleId) : totalGift
                                }/${totalGift}
                            </div>

                            ${
                                conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                    `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})'>
                                        ${window.tlAdvancedFreeGift.translation.manual_choose_gift.claim_btn}
                                    </div>` :
                                    `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                        ${window.tlAdvancedFreeGift.translation.manual_choose_gift.claimed_btn}
                                    </div> `
                            }
                        </div>
                        <div id="salepify-fg-advanced-error-${ruleId}">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                            </svg>
                            <span class="salepify-fg-advanced-error__message"></span>
                        </div>
                    </div>
                `;

                if(conditionState == window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim ++;
            }else {
                needToReload = window.tlAdvancedFreeGift.updateSelectedGifts(rule)
            }
        }

        if(listRuleNeedToAddGift.length){
            if(window.tlAdvancedFreeGift.itemsInTempCart.size){
                listRuleNeedToAddGift.map((ruleId) => {
                    window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
                })
            }else {
                const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
                if(addCartReq.status === 200){
                    window.tlAdvancedFreeGift.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim);

                  //Refresh Cart
                  refreshCart();
                  
                    if(needToReload) {
                        if(!window.TLCustomEventGiftsAdvanced){
                            window.location.reload();
                        } else if (window.TLCustomEventGiftsAdvanced == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToReload"));
                        }
                    };
                }else {
                    // Return error if there are not enough gift to add
                    const addCartRes = await addCartReq.json();
                    window.tlAdvancedFreeGift.showIconPopUpMessage(addCartRes.description, 1)
                }
            }
        }else {
            if(availableToClaim){
                window.tlAdvancedFreeGift.showIconPopUpMessage(window.tlAdvancedFreeGift.translation.gift_icon.manual, availableToClaim);
            }else {
                window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
            }
        }
        if(bodyHtml) {
            const popupIcon = document.querySelector(".salepify-fg-advanced-icon-popup__icon");
            
            popupIcon.style.display = window.tlAdvancedFreeGift.displaySettings.icon_popup.is_icon_displayed ? "block" : "none";
            window.tlAdvancedFreeGift.iconPopupElement.style.display = "flex";
            window.tlAdvancedFreeGift.iconPopupElement.style.backgroundImage = window.tlAdvancedFreeGift.displaySettings.icon_popup.is_icon_displayed ? "none" : `url(${window.tlAdvancedFreeGift.displaySettings.icon_popup.adv_free_gift_image.url})`;
      
            bodyElement.innerHTML = bodyHtml;

            if(hasRuleMetCondition){
                window.tlAdvancedFreeGift.openGiftModal();
            }
        }
        
        if(listRuleNeedToRemoveGift.length && !window.tlAdvancedFreeGift.itemsInTempCart.size){
            await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);
            if(!window.TLCustomEventGiftsAdvanced){
                window.location.reload();
            } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
            }
        }
    }

  newReRender = async () => {
        const listRuleNeedToAddGift = [];
        const listRuleNeedToRemoveGift = [];

        let availableToClaim = 0;
        let needToReload = false;
        let hasRuleMetCondition = false;
        for (let i = 0; i < window.tlAdvancedFreeGift.rules.length; i++) { 
            const rule = window.tlAdvancedFreeGift.rules[i];
            const ruleId = rule.id;
            const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = window.tlAdvancedFreeGift.getRemain(rule);
            
            if(claimedCount < canClaimCount) {
                rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
            }else if(claimedCount > canClaimCount){
                rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                    id: ruleId,
                    removeTime: claimedCount - canClaimCount
                }): null;
            }
            
            if(rule.show_free_gift_widget && window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)){
                if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                    hasRuleMetCondition = true;
                }
                const totalGift = rule.gift_qty * window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
                const mainSectionElement = document.querySelector(`#salepify-fg-advanced-main-section-${ruleId}`);

                // Offer title
                let offerTitleInnerHTML = window.tlAdvancedFreeGift.translation.main_offer.eligible_offer_title;

                if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim", "salepify-fg-advanced-main-section--claimed");
                
                    offerTitleInnerHTML = window.tlAdvancedFreeGift.handleReplaceVariable(rule, window.tlAdvancedFreeGift.getOfferTitle(rule), remain, remainSpecific, totalGift);
                }else if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM){
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--claimed");
                    mainSectionElement.classList.add("salepify-fg-advanced-main-section--allow-claim")
                }else {
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim");
                    mainSectionElement.classList.add("salepify-fg-advanced-main-section--claimed")
                }

                // Set innerHTML of offer_title
                mainSectionElement.querySelector(".salepify-fg-advanced-main-section__offer-title").innerHTML = offerTitleInnerHTML;

                // Set innerHTML of upsell_msg
                mainSectionElement.querySelector(".salepify-fg-advanced-main-section__upsell-banner").innerHTML = window.tlAdvancedFreeGift.handleReplaceVariable(
                    rule, 
                    window.tlAdvancedFreeGift.renderUpsellMsg(conditionState, rule.auto_add_gift), 
                    remain, 
                    remainSpecific, 
                    totalGift
                );

                // Footer elment
                const footerElment = mainSectionElement.querySelector(".salepify-fg-advanced-footer");
                if(!rule.auto_add_gift && conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                    //Set footer style
                    footerElment.innerHTML = `
                        <div class="salepify-fg-advanced-footer__remain-gift-title">
                            ${window.tlAdvancedFreeGift.translation.manual_choose_gift.selected_text} 
                            ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                window.tlAdvancedFreeGift.getTotalSelectedGift(ruleId) : totalGift
                            }/${totalGift}
                        </div>
                            
                        ${
                            conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" 
                                    onclick='${window.tlAdvancedFreeGift.itemsInTempCart.size > 0 ? 
                                        `window.tlAdvancedFreeGift.handleAddGiftToTempCart(${ruleId})`  :
                                        `window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})` 
                                    }'
                                >
                                    ${window.tlAdvancedFreeGift.translation.manual_choose_gift.claim_btn}
                                </div>` :
                                `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                    ${window.tlAdvancedFreeGift.translation.manual_choose_gift.claimed_btn}
                                </div> `
                        }
                    `;
                    footerElment.style.display = "flex";
                }else {
                    footerElment.style.display = "none";
                }

                const listGiftElement = mainSectionElement.querySelectorAll(`div[id^="salepify-fg-advanced-gift-${ruleId}"]`);

                listGiftElement.forEach((element) => {
                    const checkBoxElement = element.querySelector(".salepify-fg-advanced-checkbox");
                    const imageElement = element.querySelector(".salepify-fg-advanced-gift-info__img");

                    if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM){
                        if(!rule.auto_add_gift){
                            //Set show checkbox
                            checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--hide");
                            checkBoxElement.classList.add("salepify-fg-advanced-checkbox--show");
                        }

                        // Set image
                        imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                        imageElement.querySelector("svg").style.display = "none";
                    
                    }else {
                        //Set hide checkbox
                        checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--show");
                        checkBoxElement.classList.add("salepify-fg-advanced-checkbox--hide");
                        element.querySelector(".salepify-fg-advanced-gift-qty-selector").style.display = "none";

                        // Set image
                        if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                            imageElement.classList.add("salepify-fg-advanced-gift-info__img--condition-not-met");
                            imageElement.querySelector("svg").style.display = "block";
                            checkBoxElement.querySelector(".salepify-fg-advanced-checkbox__inp-cbx").checked = false;
    
                            if(!rule.auto_add_gift){
                                window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, {}); 
                            }
                        }else {
                            imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                            imageElement.querySelector("svg").style.display = "none";
                        }
                    }
                })

                if(conditionState == window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim ++;
                // Update gift selected with same buy option
                if(rule.gift_type == window.tlAdvancedFreeGift.GIFT_TYPE.SAME_BUY){ 
                    window.tlAdvancedFreeGift.updateSelectedGiftWithSameBuyOpt(rule);
                }
            }else {
                needToReload = window.tlAdvancedFreeGift.updateSelectedGifts(rule);
            }
        }

        if(listRuleNeedToAddGift.length){
            if(window.tlAdvancedFreeGift.itemsInTempCart.size){
                listRuleNeedToAddGift.map((ruleId) => {
                    window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
                })
            }else {
                const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
                if(addCartReq.status === 200){
                    window.tlAdvancedFreeGift.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim);

                  //Refresh cart
                  refreshCart();
                  
                    if(needToReload) {
                        if(!window.TLCustomEventGiftsAdvanced){
                            window.location.reload();
                        } else if (window.TLCustomEventGiftsAdvanced == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-reRender-needToReload"));
                        }
                    };
                }else {
                    // Return error if there are not enough gift to add
                    const addCartRes = await addCartReq.json();
                    window.tlAdvancedFreeGift.showIconPopUpMessage(addCartRes.description, 1)
                }
            }
        }else {
            if(availableToClaim){
                window.tlAdvancedFreeGift.showIconPopUpMessage(window.tlAdvancedFreeGift.translation.gift_icon.manual, availableToClaim);
            }else {
                // window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
            }
        }

        window.tlAdvancedFreeGift.renderTempCart();
        if(hasRuleMetCondition){
            window.tlAdvancedFreeGift.openGiftModal();
        }
        
        if(listRuleNeedToRemoveGift.length && !window.tlAdvancedFreeGift.itemsInTempCart.size){
            await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);
            if(!window.TLCustomEventGiftsAdvanced){
                window.location.reload();
            } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
            }
        }
    }
  const overwriteRenderAdvancedFreeGift = () => {
    if (window.tlAdvancedFreeGift) {
      clearInterval(intervalId);
      console.log("overwrite")
      window.tlAdvancedFreeGift.render = newRender;
      window.tlAdvancedFreeGift.reRender = newReRender;
    }
  }
  
  const intervalId = setInterval(overwriteRenderAdvancedFreeGift, 50);
  setTimeout(() => {
    clearInterval(intervalId);
  }, 3000);
  // });